import IconSelectComponent from "./IconSelect.vue";

const IconSelect = {
    install(Vue) {
        Vue.component("icon-select", IconSelectComponent);
    },
};

export default IconSelect;
